"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toTextWithBulleTalkSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var slice_1 = require("./slice");
var toTextWithBulleTalkSlice = function (data, logger) {
    return utils_1.compact(__assign(__assign({}, slice_1.toTextWithContentSlice(data, types_1.SliceType.TextWithBulleTalk, logger)), { bulleTalk: logger.required(field_groups_1.toBulleTalk(data.primary, logger)) }));
};
exports.toTextWithBulleTalkSlice = toTextWithBulleTalkSlice;
//# sourceMappingURL=text-with-bulle-talk-slice.js.map